import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	verifyingCsvData: {
		id: 'project-create-importer-upload-flow.import-in-progress-screen.verifying-csv-data',
		defaultMessage: 'Verifying your CSV data',
		description: 'Description of the import step that verifies the users csv import data',
	},
	userImport: {
		id: 'project-create-importer-upload-flow.import-in-progress-screen.user-import',
		defaultMessage: 'Setting up user profiles',
		description: 'Description of the import step that creates user profiles for their teammates',
	},
	creatingProject: {
		id: 'project-create-importer-upload-flow.import-in-progress-screen.creating-project',
		defaultMessage: 'Creating a new project',
		description: 'Description of the import step that creates the project',
	},
	errorDescription: {
		id: 'project-create-importer-upload-flow.import-in-progress-screen.error-description',
		defaultMessage: 'Contact our support team for assistance.',
		description:
			'Description to inform user that they should contact support for assistance if the import failed',
	},
	advanceErrorDescription: {
		id: 'project-create-importer-upload-flow.import-in-progress-screen.advance-error-description',
		defaultMessage:
			'Try fixing errors in the <link>error log</link> before importing again.{br}If you continue experiencing problems with your import, contact support.',
		description:
			'Description to inform user that they should return to the previous steps and try again if the import failed',
	},
	advanceErrorDesc: {
		id: 'project-create-importer-upload-flow.import-in-progress-screen.advance-error-desc',
		defaultMessage:
			'Try fixing errors in the error log before importing again.{br}If you continue experiencing problems with your import, <link>contact support</link>.',
		description:
			'Description to inform user that they should return to download error log if the import failed',
	},
	contactSupport: {
		id: 'project-create-importer-upload-flow.import-in-progress-screen.contact-support',
		defaultMessage: 'Contact support',
		description: 'Button text to contact support',
	},
	viewTroubleshootingPage: {
		// eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX - ENABLING FLAT LINT CONFIG
		id: 'project-create-importer-upload-flow.import-in-progress-screen.view-troubleshooting-page',
		defaultMessage: 'View troubleshooting page',
		description: 'Button text to troubleshoot page of the import flow',
	},
	downloadLog: {
		id: 'project-create-importer-upload-flow.import-in-progress-screen.download-log',
		defaultMessage: 'Download log',
		description: 'Button text to download error log',
	},
	startNewImport: {
		id: 'project-create-importer-upload-flow.import-in-progress-screen.start-new-import',
		defaultMessage: 'Start a new import',
		description: 'Button text to start a new import',
	},
	closeImportWindow: {
		id: 'project-create-importer-upload-flow.import-in-progress-screen.close-import-window',
		defaultMessage: 'Close import window',
		description: 'Button text to close import window',
	},
	submitFeedbackCallToAction: {
		id: 'project-create-importer-upload-flow.import-in-progress-screen.submit-feedback-call-to-action',
		defaultMessage: 'Give feedback',
		description:
			'Message for a link that will show feedback collector for user to submit feedback regarding importer',
	},
});
